
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 720 539","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".3","d":"M719.887 360.675l-156.109 8.244-37.502-366.27L447.204 0l-17.96 385.897-175.425 38.571-59.643 16.684-22.591-237.31h-45.184l-18.299 263.219L0 538.902h201.858l-5.535-71.35 81.669-20.512 151.252-24.535L421.224 539h156.9l-12.2-129.647L720 402.385l-.113-41.71zM505.943 52.899L529.89 372.55l-71.729 9.814 20.898-326.52 26.884-2.945zM145.378 241.725l11.296-.785 7.568 208.063-29.821 8.735 10.957-216.013z","fill":"currentColor"}})])
          )
        }
      }
    